var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUniqueUsersViewed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.125 13.5C1.125 13.5 0 13.5 0 12.375C0 11.25 1.125 7.875 6.75 7.875C12.375 7.875 13.5 11.25 13.5 12.375C13.5 13.5 12.375 13.5 12.375 13.5H1.125ZM6.75 6.75C7.64511 6.75 8.50355 6.39442 9.13649 5.76149C9.76942 5.12855 10.125 4.27011 10.125 3.375C10.125 2.47989 9.76942 1.62145 9.13649 0.988515C8.50355 0.355579 7.64511 0 6.75 0C5.85489 0 4.99645 0.355579 4.36351 0.988515C3.73058 1.62145 3.375 2.47989 3.375 3.375C3.375 4.27011 3.73058 5.12855 4.36351 5.76149C4.99645 6.39442 5.85489 6.75 6.75 6.75Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUniqueUsersViewed);
export default __webpack_public_path__ + "static/media/unique-users-viewed.611f3d319d9f1f4d477c903e3d17f0d9.svg";
export { ForwardRef as ReactComponent };